<template>
  <div class="page page-services">

    <!-- Hero -->
    <div class="hero services-hero">

        <div class="hero-img">
          <parallax
            direction="down"
            breakpoint="(min-width: 50px)"
          >
            <picture>
              <source srcset="../assets/img/hero/services-hero.jpg" media="(min-width: 576px)">
              <img srcset="../assets/img/hero/services-hero-m.jpg" alt="">
            </picture>
          </parallax>
        </div>

        <div class="hero-content container">
            <h1 class="page-title text-center">Services</h1>
        </div>

    </div>

    <div class="container">

      <div class="service-list">

        <div class="service-item">
          <div class="service-item-content">
            <h2>Personal Training</h2>
            <p>One on one training where I create a specific program based on your goals and help you execute every step of the way. I motivate, guide and push you to achieve new limits.</p>
            <ul class="bb-list bb-list-kettlebell-dumbbell">
              <li>60 min Session</li>
              <li>30 min Express</li>
              <li>Small Group Training</li>
            </ul>
          </div>
        </div>

        <div class="service-item">
          <div class="service-item-content">
            <h2>Bootcamp</h2>
            <p>Group Fitness on the beach consisting of High Intensity Interval Training that utilize battle ropes, kettlebells, barbells, sand bags, sprints, and much more. Have fun and build community while getting fit!</p>
            <ul class="bb-list bb-list-kb2">
              <li>Monday 7am <small class="badge badge-primary">coming soon!</small></li>
              <li>Wednesday 6:30pm <small class="badge badge-primary">coming soon!</small></li>
              <li>Saturday 10am</li>
            </ul>
          </div>
        </div>

        <div class="service-item">
          <div class="service-item-content">
            <h2>Nutrition</h2>
            <p>This class we will cover appropriate calories for your achieving your goal, macro’s, meal planning and prepping, hydration and any other questions you might have.</p>
            <ul class="bb-list bb-list-clipboard">
              <li>Monthly</li>
            </ul>
          </div>
        </div>

        <div class="service-item">
          <div class="service-item-content">
            <h2>Accountability</h2>
            <p>This is the ultimate 3 month program that gives you full access to me daily for the maximum accountability to hit your goals.</p>
            <ul class="bb-list">
              <li class="bb-list-item-kettlebell-dumbbell">Personal Training 2x wk</li>
              <li class="bb-list-item-clipboard">Nutrition &amp; Meal planning</li>
              <li class="bb-list-item-kb2">Unlimited Beach-Built Classes</li>
              <li class="bb-list-item-leaf">Daily food monitoring</li>
            </ul>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Parallax from '@/components/Parallax'

export default {
  components: {
    Parallax
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.service-item {
  margin: 0 0 rem(30) 0;
  padding: 0 0 rem(30) 0;
  border-bottom: 1px solid #e2e2e2;

  p,
  ul,
  div {
    &:last-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }
}

.service-list {

  @include media-breakpoint-up(md) {

    @include make-row();

    .service-item {
      @include make-col-ready();
      @include make-col(6);
      margin: 0;
      border: 0;

      &:last-child {
        padding-bottom: rem(30);
        margin-bottom: 0;
      }

      .service-item-content {
        height: 100%;
        padding: rem(30);
        border-radius: 30px;
        border: 1px solid #e2e2e2;
      }
    }
  }

}

</style>
